import {
    BOARD,
    BOARD_ERROR,
    BOARD_SUCCESS,
    BOARD_FILTER,
    BOARD_FILTER_ERROR,
    BOARD_FILTER_SUCCESS,
    ADD_BOARD,
    ADD_BOARD_ERROR,
    ADD_BOARD_SUCCESS,
    BOARD_DETAILS,
    BOARD_DETAILS_ERROR,
    BOARD_DETAILS_SUCCESS,
    CLEAR_ACTIVE_BOARD,
    UPDATE_BOARD,
    UPDATE_BOARD_SUCCESS,
    UPDATE_BOARD_ERROR,
    DELETE_BOARD,
    DELETE_BOARD_ERROR,
    DELETE_BOARD_SUCCESS
} from "../constants/boardsConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    boardData: [],
    activeBoard: null

};


function boardReducer(state = initialState, action) {
    switch (action.type) {
        case BOARD:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'BOARDS',
                'loadingMessage': 'THE BOARDS ARE BEING LOADED',
                'type': action.type

            });
        case BOARD_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'boardData': '',
                'type': action.type
            });
        case BOARD_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'boardData': action.data,
                'type': action.type

            });
        case BOARD_FILTER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'BOARDS',
                'loadingMessage': 'THE BOARDS ARE BEING LOADED',
                'type': action.type

            });
        case BOARD_FILTER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'boardData': [],
                'type': action.type
            });
        case BOARD_FILTER_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'boardData': action.data,
                'type': action.type

            });
        case BOARD_DETAILS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'BOARDS',
                'loadingMessage': 'THE BOARD IS BEING LOADED',
                'type': action.type

            });
        case BOARD_DETAILS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type,
                'activeBoard': null
            });
        case BOARD_DETAILS_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'activeBoard': action.data

            });

        case ADD_BOARD:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'BOARD',
                'loadingMessage': 'THE BOARD IS BEING SAVED',
                'type': action.type
            });
        case ADD_BOARD_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_BOARD_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'boardData': [...state.boardData, action.data],
                'type': action.type
            });
        case UPDATE_BOARD:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'BOARD',
                'loadingMessage': 'THE BOARD IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_BOARD_ERROR:

            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });

        case UPDATE_BOARD_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'boardData': (state.boardData) ? state.boardData.map(b => (b._id === action.data._id ? action.data : b)) : [],
                'type': action.type
            });

        case DELETE_BOARD:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'BOARD',
                'loadingMessage': 'THE BOARD IS BEING DELETED',
                'type': action.type
            });

        case DELETE_BOARD_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_BOARD_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'boardData': (state.boardData) ? state.boardData.filter(item => item._id !== action.data) : [],
                'type': action.type
            });

        case CLEAR_ACTIVE_BOARD:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'activeBoard': null
            });
        default:
            return state;
    }
};

export default boardReducer